interface MediaTranscriptArgs {
  id: string | number;
}

export const mediaTranscriptPaths = {
  show: ({ id }: MediaTranscriptArgs) => `/media_transcripts/${id}`,
  showVtt: ({ id }: MediaTranscriptArgs) => `/media_transcripts/${id}.vtt`,
};
